<template>
  <div class="main">
    <Sidebar style="height: 100vh;position: fixed;z-index: 10;"></Sidebar>
    <router-view class="content" v-wechat-title="getPageTitle($route.meta.title)" />
  </div>
</template>

<script>
import Sidebar from "@/layout/sidebar"
import { getPageTitle } from '@/utils/page-title'
export default {
  name: 'Layout',
  components: {
    Sidebar,
  },
  methods: {
    getPageTitle
  }
}
</script>

<style scoped>
.main {
  height: 100vh;
}

.content {
  height: 100vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue